import API from "./API";

export const postFreeTrialRequest = async (data) => {
    return API.post("ams/guided-reading/free-trial", data)
        .then((response) => response.data)
        .catch((error) => error.response);
};